<template>
  <div style="display:none">
      <div id="print" style="width:150px">
        <barcode style="text-align: center; height: 78px" id="pdf" v-bind:value="barcode" :width="1" :height="35" :fontSize="14" >
          rendering fails.
        </barcode>
        <div style="font-size: 12px;
          font-weight: bold;
          margin-top: -8px;
          text-align: center; 
          margin-bottom: -4px !important;" class="printprd">Rs {{ price }}</div>
        <div style="font-size: 12px;
          font-weight: bold;
          text-align: center; 
          margin-bottom: -4px !important;">{{ name }}</div>
      </div>
    </div>
</template>

<script>
import VueBarcode from "vue-barcode";
export default {
  name: "printlabels",
   components: {
    barcode: VueBarcode,
  },
  props: [
    "showPrint",
    "barcode",
    "price",
    "name",
    
  ],
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>
<style scoped>
.printprd {
          margin-bottom: -4px !important;
          font-size: 12px;
          font-weight: bold;
          text-align: center; 
          margin-bottom: -4px !important;
          }
</style>


// WEBPACK FOOTER //
// src/components/admin/PrintLabels.vue